<div [hidden]="tenderEntityService.tenderId$ | async" id="mb-container">
  <div class="px-3">
    <div class="mb-title">
      {{ 'tenders.board.title' | translate }}
    </div>
    <div class="d-flex flex-column gap-2">
      <div class="filters" [style.height.px]="showFilters ? 72 : 32">
        <div class="filters-column">
          <div class="d-flex align-items-center gap-2">
            <app-filter-status [tendersSearchService]="tendersSearchService" [items]="status" />
            <app-filter-assignment [tendersSearchService]="tendersSearchService" />
            <app-tender-toggle-text-btn [(showFilters)]="showFilters" />
          </div>
          <div class="tenders-filters" [hidden]="!showFilters">
            <app-tenders-filter
              [tenderSearchService]="tendersSearchService"
              [filters]="[FilterType.TERRITORY, FilterType.TENDER_TYPE, FilterType.MARKET_TYPE]"
              (filterChange)="onFilterChange($event)"
            />
          </div>
        </div>
      </div>
      <div class="d-flex gap-3 align-items-center">
        <app-filter-date
          [tenderSearchService]="tendersSearchService"
          (periodSelected)="periodSelected($event)"
          [defaultPeriod]="defaultPeriod"
          [ngClass]="{ 'is-firefox': browser.isFirefox }"
        />
        <app-tenders-summary [tendersSearchService]="tendersSearchService" noPeriodDisplayed class="flex-grow-1" />
        <ex-filter-text
          [placeholder]="'tenders.filter-results' | translate"
          [text]="tendersSearchService.refinedSearchText"
          (textEnter)="onRefineResults($event)"
        />
        <app-tenders-sort
          [tendersSearchService]="tendersSearchService"
          [sortFields]="[SortFieldEnum.INDEXATION_DATE, SortFieldEnum.CLOSING_DATE, SortFieldEnum.ESTIMATED_END_DATE]"
          defaultSort="closing_date"
          inBoardView
        />
        <app-tenders-action-toggle [disabled]="!tendersSearchService.tenders?.length" />
      </div>
    </div>
  </div>
  <app-tenders-list [tendersSearchService]="tendersSearchService" [tendersExportService]="tendersExportService" inBoardView />
  <app-tenders-action-bar [tendersSearchService]="tendersSearchService" />
</div>
<router-outlet></router-outlet>
